import React from 'react';
import DateRangeControl from '../../common/dateRangeControl/DateRangeControl';
import { nextSearchPeriods } from '../../store/constants/date';

const followupDateFields = [{ label: 'Follow up Date', value: 'followupAlert' }];

export const ClaimAnalysisFollowUpFilter = ({ filtersPtr, customFilter, handleRefresh, pending, disabled = false }) => {

    const setFollowupDates = (beginDate, endDate, isDateFilterActive, customField, relativeFilter) => {
        if (isDateFilterActive) {
            const dateFilter = [
                {
                    field: 'followupAlert',
                    equator: 'greater_than_or_equals_to',
                    value: beginDate,
                    relativeFilter
                },
                {
                    field: 'followupAlert',
                    equator: 'less_than_or_equals_to',
                    value: endDate,
                    relativeFilter
                }
            ];
            const existingFilters = customFilter?.filter((cf) => {
                return cf.field !== 'followupAlert';
            }) || [];
            
            filtersPtr.update(prev => ({
                ...prev,
                customFilter: [
                    ...existingFilters,
                    ...dateFilter,
                ]
            }));

        } else {
            const existingFilters = customFilter?.filter((cf) => {
                return cf.field !== 'followupAlert';
            }) || [];

            filtersPtr.update(prev => ({
                ...prev,
                isCustomFilterSetEmpty: existingFilters.length === 0,
                customFilter: existingFilters
            }));
        }
    }

    return (
        <DateRangeControl
            style={{width:"220px",marginTop:"12px"}}
            refresh={handleRefresh}
            filterName="Follow Up Range"
            setDates={setFollowupDates}
            relativeFilterOptions={nextSearchPeriods}
            fields={followupDateFields}
            customFilter={customFilter}
            hasCustomField={true}
            disabled={pending || disabled}
            defaultControlEnabled={false}
        />
    );
};
